<div class="content">
  <nrwl-monitor-license-status
    (licenseDetail)="availableLicenseCount($event)"
    [feature]="licenseType"
  ></nrwl-monitor-license-status>
</div>
<div class="datasource-container" *ngIf="isLicenseAvailable()">
  <div class="group agent-type">
    <div class="header">
      <div class="title" *ngIf="!itemSelected">Choose a type of Active test agent</div>
      <div class="title" *ngIf="itemSelected">Type of Active test agent</div>
    </div>
    <div class="datasource" *ngIf="!itemSelected">
      <div class="datasource-item" *ngFor="let item of agentTypesSource">
        <div class="datasource-item-wrapper" (click)="selectAgentType(item)">
          <div class="datasource-icon"><img [src]="item.iconName" /></div>
          <div class="datasource-item-content">
            <div class="label">{{item.label}}</div>
            <div class="description">{{item.description}}</div>
            <div class="description">{{item.subDescription}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="datasource selected-datasource" *ngIf="itemSelected">
      <div class="datasource-item">
        <div class="datasource-item-wrapper">
          <div class="datasource-icon"><img [src]="selectedAgentType.iconName" /></div>
          <div class="datasource-item-content">
            <div class="label">{{selectedAgentType.label}}</div>
            <div class="description">{{selectedAgentType.description}}</div>
            <div class="description">{{selectedAgentType.subDescription}}</div>
          </div>
          <div class="selected-item-action">
            <button class="btn btn-blue" (click)="onChangeItemSelection()">CHANGE</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="datasource-inputs">
    <form *ngIf="itemSelected" novalidate #currentForm="ngForm">
      <div class="group">
        <p *ngIf="step">Name *</p>
        <input
          autocomplete="off"
          placeholder="Enter name"
          autocomplete="off"
          name="alias"
          [(ngModel)]="alias"
          maxlength="40"
          #aliasInput="ngModel"
          (ngModelChange)="onChangeAlias()"
          required
        />
        <div
          class="error"
          *ngIf="(aliasInput.invalid && (aliasInput.dirty || aliasInput.touched)) || !isValidAlias"
        >
          <mat-error *ngIf="aliasInput.invalid && aliasInput.errors.maxlength"
            >Name is too long.</mat-error
          >
          <mat-error *ngIf="aliasInput.invalid && aliasInput.errors.required"
            >Name is required.</mat-error
          >
          <mat-error *ngIf="(aliasInput.invalid && aliasInput.errors.backend) || !isValidAlias"
            >Name already used.</mat-error
          >
        </div>
      </div>
      <div class="group" *ngIf="selectedAgentType.id !== 'hardware'">
        <p *ngIf="step">Description (optional)</p>
        <textarea
          placeholder="Description"
          name="description"
          rows="2"
          [(ngModel)]="step.output.description"
        ></textarea>
      </div>
      <platform-choice
        *ngIf="selectedAgentType.id !== 'hardware' && selectedAgentType.id !== 'windows'"
        [parentOutput]="step.parent.output"
        [step]="step"
        [key]="'platform'"
        (onUpdate)="step.dataValueChange('platformChoice', $event.key, $event.value)"
      >
      </platform-choice>

      <claim-code
        *ngIf="selectedAgentType.id === 'hardware'"
        [parentOutput]="step.parent.output"
        [step]="step"
        [key]="'hwLockCode'"
        (onUpdate)="step.dataValueChange('hwLockCodeSettings', $event.key, $event.value, $event.isValid)"
      >
      </claim-code>
    </form>
  </div>
</div>
<div class="content" *ngIf="showLicenseMessage()">
  <div class="monitor-license-info">
    <h1>You have reached your data source limit.</h1>
    <p>
      Creating a new data source would exceed your license limit. You can remove one of your data
      sources or contact VIAVI to increase your limit.
    </p>
  </div>
</div>
